export const MAIN_NAV_TRACK = {
  EVENT: 'e_mainNav',
  TOP_MENU_CONTEXT: 'Top Menu',
  TOP_SUBMENU_CONTEXT: 'Top Sub Menu',
  ALL_CATEGORIES_TEXT: 'All Categories',
  CATEGORIES_TEXT: 'Categories ',
  HELP_CENTER_TEXT: 'Help center',
  LOGO_CLICK_TEXT: 'Logo Click',
  MORE_TEXT: 'More',
  PARTS_MANUAL_TEXT: 'Parts Manuals',
  PARTS_DIAGRAM_TEXT: 'Parts Diagram',
  QUICK_ORDER_TEXT: 'Quick Order',
  SIS_TEXT: 'SIS ',
  SPECIALS_TEXT: 'Specials',
  SHOP_ALL_CATEGORIES: 'Shop all categories',
  CONTROL_CENTER_TEXT: 'Control Center',
  PERSONAL_INFORMATION_TEXT: 'Personal Information',
  MY_EQUIPMENT_TEXT: 'My Equipment',
  ORDER_HISTORY_TEXT: 'Order History',
  ORDER_TO_APPROVE_TEXT: 'Order to Approve',
  PENDING_QUOTES_TEXT: 'Pending Quotes',
  SAVED_LISTS_TEXT: 'Saved Lists',
  NOTIFICATION_PREFERENCES_TEXT: 'Notification Preferences',
  SHOPPING_PREFERENCES_TEXT: 'Shopping Preferences',
  ADDRESS_BOOK_TEXT: 'Address Book',
  CUSTOMER_CARE_HOME_TEXT: 'Cat Customer Care Home',
  TRANSACT_AS_GUEST_TEXT: 'Transact As Guest',
  CONTROL_CENTER_PAGE_PATH: 'Control Center',
  ORDERS_TO_APPROVE_PENDING_TEXT: 'Pending',
  ORDERS_TO_APPROVE_EXPIRING_TEXT: 'Expiring',
  RECENT_ORDERS_TEXT: 'Orders',
  CAT_VANTAGE_REWARDS_TEXT: 'Cat Vantage Rewards',
  Invoice_page: 'Invoices'
};

export const SAVE_EQUIPMENT = 'Save Equipment';
export const FORM_SAVE_EQUIPMENT = 'Step 3 | add equipment | save equipment';
export const SELECT_EQUIPMENT_DRAWER_VIEW =
  'Step 1 | Centralized Select Equipment drawer view';
export const ADD_EQUIPMENT_DRAWER_VIEW = 'Step 1 | Add Equipment drawer view';
export const ADD_EQUIPMENT_BY_MODEL = 'By Model | add equipment';
export const GA_FORM_NAME_BY_SERIAL = 'By Serial Number | add equipment';
export const GA_LOCATION_FOR_MEQ = 'Add your equipment to find parts that fit';
export const EVENT_FORM_SUBMITTED = 'formSubmitted';
export const EVENT_FORM_VISIBLE = 'formVisible';
export const EVENT_IMPRESSION_READY = 'impressionReady';
export const EVENT_TRANSACTION_READY = 'transactionReady';
export const EVENT_PURCHASE = 'purchase';
export const EVENT_PRODUCT_CLICK = 'productClick';
export const EVENT_RECENTLY_VIEWED = 'CC PCC Recently Viewed';
export const EVENT_CORE_TRACKING_WIDGET = 'PCC CC Core Tracking widget';
export const STATUS_SUCCESS = 'Success';
export const STATUS_FAIL = 'Fail';
export const NETWORK_ERROR = 'Network Error';
export const ORDER_STATUS_ITEM_LINK_GA_LIST_NAME = 'PCC order status page';
export const EVENT_REFUND = 'refund';
export const SYSTEM_ERROR = 'system error';
export const SAVED_LISTS_PAGE_PATH = 'SavedLists';
export const SAVED_LISTS_FORM_NAME = 'SavedListSearch';
export const NO_SEARCH_RESULTS = 'no search results';
export const SEARCH_MY_EQUIPMENT = 'search my equipment';
export const PCC_MY_EQUIPMENT_PAGE = 'PCC My equipment Page';
export const FACET_SEARCH = 'Facet search';
export const FACET_DRAWER_SEARCH = 'Facet drawer search';
export const CC_NAV_TRACK = {
  GO_TO_CART: 'Go to Cart',
  RECENTLY_VIEW_SHOP_PART: 'Recently Viewed - Shop Parts',
  BROWSE_CATALOG: 'Browse Catalog',
  TAKE_A_TOUR: 'Take a Tour',
  LEAVE_FEEDBACK: 'Leave Feedback',
  CUSTOMIZE: 'Customize',
  APPLY: 'Update',
  CANCEL: 'Cancel',
  HELP_SUPPORT: 'Help_Support',
  SET_START_PAGE: 'Set Start Page',
  SHOPPING_PREFERENCES: 'Shopping Preferences',
  VIEW_ALL: 'View All',
  SIS: 'SIS',
  QUICK_ORDER: 'Quick Order',
  ADD_TO_CART: 'Add to Cart',
  SAVED_LIST_DETAILS: 'PCC Saved List Details',
  RECENT_ORDERS: 'Recent Orders',
  ALL_ORDERS: 'All Orders',
  REORDER: 'Reorder',
  TRACK_ORDER: 'Track Order',
  VIEW_ORDER: 'View Order',
  VIEW_ALL_ORDERS: 'View All Orders',
  GO_TO_CORE_TRACKING: 'Go to Core Tracking',
  VIEW_PRODUCT: 'View Product',
  VIEW_PENDING: 'View Pending',
  VIEW_EXPIRING: 'View Expiring',
  PLACE_ORDER: 'Place Order',
  ORDERS_TO_APPROVE: 'Orders to Approve',
  EXPIRING_ORDERS: 'Expiring Orders',
  APPROVE: 'Approve',
  REJECT: 'Reject',
  DELETE: 'Delete',
  PENDING_QUOTES: 'Pending Quotes',
  VIEW_QUOTE: 'View Quote'
};
export const STATUS_FAILURE = 'failure';
export const CART_TRACK_EVENT_ATTRIBUTES = {
  //event constants
  CART_EVENT: 'e_primaryCTA',
  //context constants
  SHOPPING_CART_CONTEXT: 'Shopping cart section',
  REMOVE_ITEM_MODAL_CONTEXT: 'remove item modal',
  //text constants
  SAVE_ITEM_TEXT: 'save to list item level icon',
  TRASH_ICON_TEXT: 'delete item level icon',
  REMOVE_BUTTON_TEXT: 'remove',
  CANCEL_BUTTON_TEXT: 'cancel',
  CHECKOUT_TEXT: 'Proceed to checkout',
  ADD_ITEMS_TEXT: 'Add your items',
  COPY_LINK_TEXT: 'Share cart modal'
};
export const FORM_FIELD_ERROR = 'error';
export const DEFAULT_BRAND = 'Cat';
export const DEFAULT_BUSINESS_UNIT = 'PCC';
export const LIST_ORDER_CONFIRMATION = 'PCC Order Confirmation';
export const LIST_QUEUED_ORDER = 'PCC Queued Order Confirmation';
export const LOGGED_IN_B2B = 'Logged In B2B';
export const LOGGED_IN_IA = 'Logged In IA';
export const LOGGED_IN_CSP = 'Logged in CSP';
export const GUEST = 'Guest';
export const CHECKFITMENT = 'fitn';
export const PARTS_DIAGRAM_PAGE = 'PCC Parts Diagram Page';
export const PENDING_QUOTE_VIEW = 'PendingQuoteView';
export const ADD_TO_CART = 'addToCart';
export const ADD_TO_CART_GA4 = 'add_to_cart';
export const BEGIN_CHECKOUT = 'begin_checkout';
export const EVENT_SELECT_ITEM = 'select_item';
export const EVENT_REMOVE_FROM_CART = 'remove_from_cart';
export const VIEW_CART_EVENT = 'view_cart';
export const VIEW_ITEM_LIST_EVENT = 'view_item_list';
export const SAVED_LIST_DETAILS_EVENT = 'PCC Saved List Details';
export const VIEW_ITEM = 'view_item';
export const ADD_TO_WISHLIST = 'add_to_wishlist';
export const DEBOUNCE_TIME_FIREVENT = 1000;
export const FORM_LOCATION = 'PCC Home Page';
export const GA_CONTEXT_TEXT = 'Homepage Currently Shopping for section';
export const EVENT_VIEW_PROMOTION = 'view_promotion';
export const EVENT_SELECT_PROMOTION = 'select_promotion';
export const ESPOT_TYPES = {
  CAROUSEL: 'carousel_promotion',
  STATIC: 'static_promotion'
};

export const GA_PDP_DIAGRAM = 'PCC PDP Diagram';
export const CONTENT_VISIBLE_EVENT = 'content_visible';
export const CSR_SHARE_STOREID = 'storeId';
export const CSR_SHARE_FLOW = 'isCsrShared';
export const INVOICE_ERROR_EVENT = 'error';
export const INVOICE_TABLE_LEVEL_ERROR = 'table level error';
export const INVOICE_PAGE_LEVEL_ERROR = 'page level error';
export const INVOICE_PREVIEW_LEVEL_ERROR = 'preview level error';
export const INVOICE_DOWNLOAD_LEVEL_ERROR = 'download level error';
export const SORRY_ERROR_OCCURRED = 'Sorry, an error occurred';
export const INVOICE_PREVIEW_ERROR_MESSAGE =
  'We are unable to load your invoice preview due to a technical issue.';
export const INVOICE_DOWNLOAD_ERROR_MESSAGE =
  'We ran into a problem downloading invoice. Please try again.';
export const INVOICE_PREVIEW_ERROR_CODE = 'Invoice preview failed';
export const INVOICE_DOWNLOAD_ERROR_CODE = 'Invoice download failed';
export const INVOICE_TABLE_ERROR_CODE = 'Invoice table failed';
export const INVOICE_PAGE_ERROR_CODE = 'Invoice page failed';
export const FILL_SEARCH_FIELDS =
  'We are unable to complete your search request. At least one field must be populated to continue. Please try again.';
export const CSR_SEARCH_PAGE = 'csr page failed';
export const GA_PDP_PARTS_DIAGRAM = 'PCC PDP Parts Diagram Page';
export const GA_PDP_DEFAULT_DIAGRAM = 'PCC PDP Default Diagram View';
export const GA_PDP_LIST_DIAGRAM = 'PCC PDP List Diagram View';
export const SHOPPING_PREFERENCES_GA_TRACK_ATTRIBUTES = {
  YES: 'Y',
  NO: 'N',
  NA: 'NA',
  FORM_LOCATION: 'PCC shopping preference page',
  STATUS_SUCCESS: 'success',
  STATUS_FAIL: 'fail',
  API_FAILED: 'api failed',
  EVENT: 'e_primaryCTA',
  TEXT: 'save preferences',
  CONTEXT: 'shopping preferences page',
  CSP_TEXT: 'Apply new settings',
  CSP_CONTEXT: 'shopping preference csp page',
  CSP_FORM_NAME: 'Shopping Preferences - Dealer Settings - CSP'
};

export const GA_PRIMARY_CTA = 'e_primaryCTA';
export const GA_ADD_ALL_TO_CART_CTA = 'Add all to cart';
export const GA_PDP_LIST_VIEW_FOOTER_SECTION =
  'Parts Diagram List view footer section';
export const GA_PDP_LIST_VIEW_SECTION = 'Parts Diagram List view section';
export const GA_PDP_DEFAULT_VIEW_SECTION =
  'Parts Diagram default view page footer section';
export const GA_CONTACT_DEALER = 'Contact Dealer';
export const GA_CHECK_PRICE = 'Check price';
export const GA_ADD_TO_CART = 'Add to cart';
export const PARTS_DIAGRAM_VIEW_SECTION = 'Parts Diagram view section';
export const PARTS_DIAGRAM_DEFAULT_VIEW_SECTION =
  'Parts Diagram default view page footer section';
